var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app-bar',{staticClass:"rounded-b-xl pl-5 pr-5",attrs:{"app":"","color":"#FFFFFF","elevate-on-scroll":""}},[_c('v-toolbar-title',{staticClass:"mb-1"},[_c('AppLogo')],1),_c('v-spacer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }